/**
 * Each tab's native stack id. Kept apart from `tabs.ts`, which imports the routing barrel, so the
 * pane code can map a native stack to its tab without loading the router.
 */
export const TAB_STACK_IDS = {
  home: "home-stack",
  chat: "chat-stack",
  team: "team-stack",
  account: "account-stack",
} as const;

export type TabStackTab = keyof typeof TAB_STACK_IDS;

/** The tab whose own stack is `stackId`, if any. */
export const tabOfStack = (stackId: string): TabStackTab | undefined =>
  (Object.keys(TAB_STACK_IDS) as TabStackTab[]).find((tab) => TAB_STACK_IDS[tab] === stackId);
